import { Display, Sizes, Colors, Button } from "../Button/Button";

function Header(props: {
	title: string,
	onClose: () => void
}) {

	const { onClose, title } = props;

	return (
		<div className="modal__header">
			<h4><b>{title}</b></h4>

			<Button
				className="modal-close"
				key="header-cancel"
				icon={{ icon: 'cross', iconPos: 'icon-only' }}
				display={Display.Text}
				onClick={onClose}
				sizes={Sizes.Medium}
				colors={Colors.Error}
				labelVisible={false}
			>
				Cancel
			</Button>
		</div>

	)
}

function SectionTitle(props: { name: string }) {
	const { name } = props;
	return <h5>{name}</h5>
}

export const MvsModal = {

	Header: Header,
	SectionTitle: SectionTitle,
	ContentEmpty: () => <text className="txt-lg-body">There are no available motor vehicle search product to select. Contact support for assistance.</text>
}

